import initTeamDetails from './modules/teamDetails';

$(document).ready(() => {
    initTeamDetails();
});
